export const REGEX_CONDITION = {
  PLACEHOLDER: /=(\[|\{{)(.*?)(\]|\}})/gi,
  LEADING_AND_TRAILING_SLASHES: /^\/+|\/+$/g,
  SLASHES: /\/+/g,
  A_PLUS_DIGITS: /a\d[^_]+/g,
  ADJUST_REGEX: /(app\.adjust\.com|pixum\.go)/,
};

export const URL_PARAMS_KEY = {
  DEEP_LINK: 'deep_link',
};

export const CLICK_ID = {
  PREFIX: 'clickid_',
  SEPERATOR: '~',
};

export const CREATIVE_ID = {
  CONTENT: 'content',
  KEY_VISUAL: 'key-visual',
  HEADER: 'header',
  MAGAZINE: 'magazine',
  FOOTER: 'footer',
};

export const SCREEN_SIZES = {
  mobile: 0,
  tablet: 768,
  desktop: 960,
} as const;
